import { z } from "zod";

const wifiNetworkSchema = z.strictObject({
  type: z.literal("wifi").describe("The type of network connection"),
  signal: z
    .int32()
    .max(0)
    .describe("The WiFi signal strength in dBm. Typically between -200 and 0"),
  // ssid: z.string().describe("The SSID of the WiFi network"),
  // ip: z
  //   .union([z.ipv4(), z.ipv6()])
  //   .describe("The IP address assigned to the device (IPv4 or IPv6)"),
});

const cellularNetworkSchema = z.strictObject({
  type: z.literal("cell").describe("The type of network connection"),
  signal: z.int32().max(0).describe("The RSRP in dBm"),
});

export const networkSchema = z
  .discriminatedUnion("type", [wifiNetworkSchema, cellularNetworkSchema])
  .describe("Network connection details");
